import React, { useState, useEffect, useRef } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import am5themes_Dark from "@amcharts/amcharts5/themes/Dark";
import am5themes_Responsive from "@amcharts/amcharts5/themes/Responsive";
import * as am5plugins_exporting from "@amcharts/amcharts5/plugins/exporting";

import logo from './logo.svg';

function GraficaBrechas(props) {

    const rootRef = useRef(null);
    const yAxisRef = useRef(null);
    const xAxisRef = useRef(null);
    const chartRef = useRef(null);

    // This code will only run one time
    useEffect(() => {
        let root = am5.Root.new("chartdiv", {
            useSafeResolution: false // This may cause performance issues on some devices (like mobiles running iOS 15)
        });

        let themes = [am5themes_Animated.new(root),
        am5themes_Responsive.new(root)
        ]
        if (props.darkMode) {
            themes.push(am5themes_Dark.new(root));
        }
        root.setThemes(themes);

        let chart = root.container.children.push(
            am5xy.XYChart.new(root, {
                panY: true,
                panX: true,
                layout: root.verticalLayout,
                wheelX: "panX",
                wheelY: "zoomX"
            })
        );

        // Create Y-axis
        let yAxis = chart.yAxes.push(
            am5xy.ValueAxis.new(root, {
                renderer: am5xy.AxisRendererY.new(root, {
                    opposite: false
                }),
                visible: true
            })
        );

        let rendering = am5xy.AxisRendererX.new(root, {
            minGridDistance: 10
        })
        rendering.grid.template.location = 0;
        // Create X-Axis
        let xAxis = chart.xAxes.push(
            am5xy.CategoryAxis.new(root, {
                start: 0,
                renderer: rendering,
                categoryField: "category"
            })
        );
        var xRenderer = xAxis.get("renderer");
        xRenderer.grid.template.setAll({
            location: 0.5,
            multiLocation: 0
        });

        rendering.grid.template.setAll({
            location: 0.5,
            multiLocation: 0
        });

        var tooltip = am5.Tooltip.new(root, {
            pointerOrientation: "down",
            width: am5.percent(20),
            labelOversizedBehavior: "wrap"
        })

        tooltip.label.setAll({
            maxWidth: am5.percent(20),
            oversizedBehavior: "wrap"
        });


        xAxis.labelsContainer.set("tooltip", tooltip);



        // rendering.labels.template.set("fill", am5.color("#c99"));
        //rendering.labels.template.set("tooltipText", "{labelName}");
        rendering.labels.template.set("oversizedBehavior", "wrap");
        rendering.labels.template.set("maxWidth", 120);
        rendering.labels.template.set("textAlign", "center");
        rendering.labels.template.setup = function (target) {
            target.set("background", am5.Rectangle.new(root, {
                fill: am5.color(0x000000),
                fillOpacity: 0
            }));
        }


        chart.set("scrollbarX", am5.Scrollbar.new(root, {
            orientation: "horizontal",
            start: 0,
        }));
        chart.set("scrollbarY", am5.Scrollbar.new(root, { orientation: "vertical" }));




        // Add cursor
        let cursor = am5xy.XYCursor.new(root, {})
        cursor.lineX.setAll({
            visible: false
        });
        chart.set("cursor", cursor);

        cursor.events.on("cursormoved", function (ev) {
            let x = ev.target.getPrivate("positionX");
            let y = ev.target.getPrivate("positionY");

            let dateX = xAxis.axisPositionToIndex(x);
            let valueY = yAxis.positionToValue(y);
            //console.log("x: ", dateX);
            //console.log("y: ", valueY);
        });

        var exporting = am5plugins_exporting.Exporting.new(root, {
            menu: am5plugins_exporting.ExportingMenu.new(root, {}),
            filePrefix: "grafica",
            title: "Graficá correlacional",
            pdfOptions: {
                includeData: true
            }
        });

        chart.appear(1000, 100);
        xAxisRef.current = xAxis;
        yAxisRef.current = yAxis;
        rootRef.current = root;
        chartRef.current = chart;

        return () => {
            root.dispose();
        };
    }, []);

    useEffect(() => {
        if (rootRef.current) {
            let themes = [am5themes_Animated.new(rootRef.current),
            am5themes_Responsive.new(rootRef.current)
            ]
            if (props.darkMode) {
                themes.push(am5themes_Dark.new(rootRef.current));
            }
            rootRef.current.setThemes(themes);
        }
    }, [props.darkMode]);


    // This code will only run when props.data changes
    useEffect(() => {

        // set X data
        xAxisRef.current.data.setAll(props.data.ejes);

        // Clear old series
        let size = chartRef.current.series.length.valueOf()
        for (let index = 0; index < size; index++) {
            chartRef.current.series.removeIndex(0).dispose();
        }

        props.data.plot.forEach(item => {
            if (item.length > 0) {
                let series = chartRef.current.series.push(
                    am5xy.LineSeries.new(rootRef.current, {
                        xAxis: xAxisRef.current,
                        yAxis: yAxisRef.current,
                        valueYField: "value",
                        categoryXField: "category",
                        fill: am5.color(item[0].color),
                        stroke: am5.color(item[0].color),
                    })
                );
                series.data.setAll(item);
            }
        })

        props.data.scatter.forEach(item => {
            if (item.length > 0) {

                let series = chartRef.current.series.push(
                    am5xy.LineSeries.new(rootRef.current, {
                        xAxis: xAxisRef.current,
                        yAxis: yAxisRef.current,
                        valueYField: "value",
                        categoryXField: "category",
                        fill: am5.color(item[0].color),
                        stroke: am5.color(item[0].color),
                        connect: false
                    })
                );
                series.data.setAll(item);
                series.strokes.template.set("strokeWidth", 3.5);
                series.strokes.template.set("strokeDasharray", [2, 1]);
                series.strokes.template.set("tooltipText", "[#FFFFFF]" + item[0].name + ": " + (Math.round((item[0].value + Number.EPSILON) * 100) / 100) + "[/]");
                series.strokes.template.set("interactive", true);
                series.strokes.template.states.create("hover", {
                    strokeWidth: 5,
                    stroke: am5.color(item[0].color)
                });


                var tooltip = am5.Tooltip.new(rootRef.current, {
                    getFillFromSprite: false,
                    getStrokeFromSprite: true,
                    autoTextColor: true,
                    getLabelFillFromSprite: true,
                    labelText: "[#000000]" + item[0].name + ": " + (Math.round((item[0].value + Number.EPSILON) * 100) / 100) + "[/]",
                    pointerOrientation: "horizontal",
                });


                tooltip.get("background").setAll({
                    fill: am5.color(0xffffff),
                    fillOpacity: 0.8
                });


                if (props.tooltip) {
                    series.set("tooltip", tooltip);
                }

                series.bullets.push(function () {

                    var circle = am5.Circle.new(rootRef.current, {
                        radius: 5,
                        interactive: true, //required to trigger the state on hover
                        fill: series.get("fill"),
                        opacity: item.length > 1 ? 1 : 0.7
                    });

                    circle.states.create('hover', {
                        scale: 1.5,
                    });

                    circle.set("tooltipText", "[#FFFFFF]" + item[0].name + ": " + (Math.round((item[0].value + Number.EPSILON) * 100) / 100) + "[/]")


                    let bullet = am5.Bullet.new(rootRef.current, {
                        sprite: circle
                    });

                    return bullet

                });

            }
        })





    }, [props]);


    return <div id="chartdiv" style={{ width: "100%", height: "calc(100vh - 170px)" }}></div>;
}


export default GraficaBrechas;